module.exports = "<div id=\"preloader\">\n    <div id=\"loader\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./sources/components/common/loader/loader.html
// module id = 741
// module chunks = 0